module.exports = function getResource(label, vars = []) {
    let resources = {
        checkboxContentDefaultText: 'J’accepte les',
        checkboxContentDefaultLink: 'conditions'
    };
    return resources[label];
};
